$(function (){
    /* alert get pathname en or id */
    var detectLang = window.location.pathname.split('/')[1];

    /* letter animate */
    if( detectLang == "en" || detectLang == "EN"){
        var strLine2 = "The new food estate program is very likely to repeat the same unfortunate mistakes. Without clear planning or a commitment to preserving the environment and society, communities will once again suffer.";
    } else{
        var strLine2 = "Program Food Estate rawan mengulang sejarah yang buruk. Tanpa kejelasan perencanaan serta komitmen menjaga keseimbangan lingkungan dan sosial, lagi-lagi masyarakat yang akan kena batunya.";
    }
    
    var spansLine2 = '<span>' + strLine2.split(/\s+/).join(' </span><span>') + '</span>';

    //start letter animate
    new ScrollMagic.Scene({
        offset : "-450",
        triggerElement: '.section-5-1',
        triggerHook: 0, // Trigger this scene when top of panel enters view
        reverse: true, // play animation only once going forward
    })
    .on('enter', function(e) {
        $('#line2 span').remove();

        /* letter animate */
        $(spansLine2).addClass('hide').appendTo('#line2').each(function(i){
            //console.log(i);
            $(this).delay(100 * i).fadeTo('slow', 1);

            if( detectLang == "en" || detectLang == "EN"){
                if( i == 2 ){
                    $(this).addClass("italic");
                }
                if( i == 3 ){
                    $(this).addClass("italic");
                }
            } else{
                if( i == 1 ){
                    $(this).addClass("italic");
                }
                if( i == 2 ){
                    $(this).addClass("italic");
                }
            }
        });
    })
    .addTo(require('../scrollInit'));
});